import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import History from './components/history';
import { getList as _getList } from "@api/correspondence/reminder";
export default {
  name: "correspondence-reminder",
  data: function data() {
    return {
      searchKey: '',
      byGroup: false,
      filterData: [],
      dataList: [{}],
      template: null
    };
  },
  methods: {
    showHistory: function showHistory(item) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$awaitTo(_this.$dialog(History, {
                dialog: {
                  title: '【函证编号】催函记录',
                  appendToBody: false
                },
                props: {}
              }, function (template) {
                _this.template = template;
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.template = null;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    search: function search() {},
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$awaitTo(_getList({
                params: {
                  searchkey: _this2.searchKey,
                  group: _this2.byGroup
                },
                data: {
                  // "combineSearch": "string",
                  "page": 1,
                  "length": 10
                  // "order": "string"
                }
              }));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              console.log(data);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};